import { render, staticRenderFns } from "./IndexCategory.vue?vue&type=template&id=70b696c1"
import script from "./IndexCategory.vue?vue&type=script&lang=js"
export * from "./IndexCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports